export default __webpack_public_path__ + "static/habilidades-150f26cb74277dc31b9ae5a846410ddd.jpeg";